export default __webpack_public_path__ + "static/enemy-metal-81a2f503ee43db6f3bdc02c0f0eaef88.png";